import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logoIcon from '../assets/logo-icon-exact.png';
import Footer from '../components/Footer';

const EDGE_FN_URL = 'https://rvxlugwkeqfdghwbholl.supabase.co/functions/v1/send-contact-email';

function Contact() {
  const navigate = useNavigate();

  const [fromEmail, setFromEmail] = useState('');
  const [subject, setSubject]     = useState('');
  const [message, setMessage]     = useState('');
  const [loading, setLoading]     = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError]         = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!fromEmail || !subject || !message) {
      setError('Please fill in all fields.');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fromEmail)) {
      setError('Please enter a valid email address.');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(EDGE_FN_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ fromEmail, subject, message }),
      });
      const data = await res.json();
      if (!res.ok || !data.success) {
        setError(data.error || 'Something went wrong. Please try again.');
        setLoading(false);
        return;
      }
      setSubmitted(true);
    } catch (_) {
      setError('Could not send your message. Please check your connection and try again.');
      setLoading(false);
    }
  };

  return (
    <div className="settings-page">
      <header>
        <div className="logo" onClick={() => navigate('/')}>
          <div className="logo-icon"><img src={logoIcon} alt="" /></div>
          <div className="logo-text">TradeReady<span>Pro</span></div>
        </div>
        <div className="header-right">
          <Link to="/quiz" className="dark-toggle">Home</Link>
          <Link to="/settings" className="dark-toggle" title="Settings">⚙️</Link>
        </div>
      </header>

      <div className="settings-wrap" style={{ maxWidth: 720 }}>
        <button className="settings-back" onClick={() => navigate(-1)}>← Back</button>
        <h1 className="settings-title">Contact Us</h1>

        <div className="settings-section">
          <div className="settings-section-title">We'd love to hear from you</div>
          <ul className="static-content" style={{ marginTop: '0.25rem' }}>
            <li><strong>Tech issues</strong> — quiz not loading, billing trouble, account problems</li>
            <li><strong>Billing</strong> — refunds, plan changes, receipts</li>
            <li><strong>Feature requests</strong> — something missing from a study track you need</li>
            <li><strong>Partnerships</strong> — union halls, colleges, training programs</li>
          </ul>
          <p style={{ marginTop: '1rem', fontSize: '0.95rem', color: 'var(--text-muted)', lineHeight: 1.65 }}>
            Your opinion matters. An administrator will respond personally within 48 hours.
          </p>
        </div>

        {!submitted ? (
          <div className="settings-section">
            {error && <div className="auth-error" style={{ marginBottom: '0.75rem' }}>{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Your Email</label>
                <input
                  type="email"
                  value={fromEmail}
                  onChange={e => setFromEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                />
              </div>
              <div className="form-group">
                <label>Subject</label>
                <input
                  type="text"
                  value={subject}
                  onChange={e => setSubject(e.target.value)}
                  placeholder="What's on your mind?"
                  required
                />
              </div>
              <div className="form-group">
                <label>Message</label>
                <textarea
                  rows={6}
                  value={message}
                  onChange={e => setMessage(e.target.value)}
                  placeholder="Tell us what you need..."
                  required
                  style={{
                    width: '100%', padding: '0.7rem 1rem',
                    border: '1.5px solid rgba(12,31,63,0.15)',
                    borderRadius: '8px', fontSize: '1rem',
                    fontFamily: 'inherit', resize: 'vertical',
                    background: 'var(--cream)', color: 'var(--text)',
                    outline: 'none', transition: 'border-color 0.15s',
                    boxSizing: 'border-box',
                  }}
                />
              </div>
              <button type="submit" className="btn-auth" disabled={loading}>
                {loading ? 'Sending…' : 'Send Message'}
              </button>
            </form>
          </div>
        ) : (
          <div className="settings-section">
            <div className="auth-success" style={{ fontSize: '1rem' }}>
              Message sent — thanks!
            </div>
          </div>
        )}

        <p style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: '1rem', fontStyle: 'italic',
          color: 'var(--gold)', textAlign: 'center',
          marginTop: '2rem', marginBottom: '1rem',
        }}>
          "Built for Electricians by Electricians."
        </p>
      </div>

      <Footer />
    </div>
  );
}

export default Contact;
